import { Alert } from '@mui/material';
import { CustomNoRowsOverlayProps } from 'ag-grid-react';
import { FC } from 'react';

export const CustomNoRowsOverlay: FC<
    CustomNoRowsOverlayProps & { error: boolean; noRowsMessageFunc: () => string }
> = ({ error, noRowsMessageFunc }) => {
    return <Alert severity={error ? 'error' : 'info'}>{noRowsMessageFunc()}</Alert>;
};
